// Read a media file's duration from its metadata alone — no decode, no full
// read. Used to set expectations for a queue before anything is processed.
//
// Its own module so it can be swapped out in tests: jsdom has no media stack
// and never fires the metadata event.

export function probeDuration(url) {
  return new Promise((resolve) => {
    const el = document.createElement('audio');
    el.preload = 'metadata';

    let settled = false;
    const done = (value) => {
      if (settled) return;
      settled = true;
      el.removeAttribute('src');
      resolve(value);
    };

    el.onloadedmetadata = () => done(Number.isFinite(el.duration) ? el.duration : null);
    el.onerror = () => done(null);
    // A container the browser can't parse (our own legacy WAV codecs included)
    // simply won't report one; the real duration arrives after decoding.
    setTimeout(() => done(null), 2000);

    el.src = url;
  });
}
